define(function (require) {
    require('semantic-ui-css/semantic.min.css'); // ставим первым, чтобы в main.scss перезаписать базовые свойства
    require('sass/main.scss');
    require('lib/legacy');
    require('mrg-polyfills');
    require('intersection-observer');
    require('fullscreen-api-polyfill');
    const Application = require('Cloud/Application');
    const { sendAppReady } = require('lib/app-ready');
    const { captureException } = require('@sentry/browser');
    const { routeStatusPage } = require('reactApp/modules/router/router.module');
    const { initPromoController } = require('reactApp/modules/promo/promo.module');
    const { store } = require('reactApp/store');

    const { EStatus } = require('reactApp/sections/ErrorPage/ErrorPage.types');

    try {
        window.app = new Application();

        const { initSaga } = require('reactApp/store');
        const { rootSaga } = require('reactApp/rootSaga');

        initSaga(rootSaga);

        if (app.user.isAuthorized() || app.isPublic()) {
            if (app.isEditor() || (app.editor && app.editor.isEditor())) {
                app.editor.start();
                app.start();
            } else {
                app.start();
            }
        } else {
            app.ui.login.show({ fromStart: true });
        }

        if (!app.isPublic() && !app.getParam('ON_PREMISE') && (!app.editor || !app.editor.isEditor())) {
            require('reactApp/utils/firebase').initializeFirebase();
        }

        store.dispatch(initPromoController());

        sendAppReady();
    } catch (error) {
        sendAppReady(error);
        captureException(error);

        store.dispatch(routeStatusPage({ status: EStatus.INTERNAL_SERVER_ERROR }));
    }
});
